
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Wait for the DOM to be ready before initializing
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    // Initialize React first
    createRoot(rootElement).render(<App />);
    
    // Then initialize PWA elements after React is mounted
    defineCustomElements(window);
  }
});
